/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Organizationid1Inputs */

const en__field_organizationid1 = /** @type {(inputs: _Field_Organizationid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization`)
};

/** @type {(inputs: _Field_Organizationid1Inputs) => LocalizedString} */
const de__field_organizationid1 = en__field_organizationid1;

/**
* | output |
* | --- |
* | "Organization" |
*
* @param {_Field_Organizationid1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_organizationid1 = /** @type {((inputs?: _Field_Organizationid1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Organizationid1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_organizationid1(inputs)
	return de__field_organizationid1(inputs)
});
export { _field_organizationid1 as "_field_organizationId" }